const formatTranslationsKey = (template: string, variables: Record<string, string>) => {
  return Object.keys(variables).reduce(
    (result, key) => result.replace(new RegExp(`{{${key}}}`, "g"), variables[key]),
    template,
  )
}

export { formatTranslationsKey }
